import { render, staticRenderFns } from "./PuzzleGrid.vue?vue&type=template&id=1267ee9e&scoped=true&"
import script from "./PuzzleGrid.vue?vue&type=script&lang=ts&"
export * from "./PuzzleGrid.vue?vue&type=script&lang=ts&"
import style0 from "./PuzzleGrid.vue?vue&type=style&index=0&id=1267ee9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267ee9e",
  null
  
)

export default component.exports